import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../styles/Checkout.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { createOrder, clearCart } from '../../Store/user/userSlice';

const Checkout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cart, currentUser } = useSelector(({ user }) => user);
  
  const [values, setValues] = useState({
    lastName: '',
    firstName: '',
    telephone: '',
    citi: '',
    department: '',
    carrier: '',
    payment: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = ({ target: { value, name } }) => {
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const isNotEmpty = Object.values(values).every((val) => val);

    if (!isNotEmpty) {
      setMessage({ type: 'error', text: 'Заповніть усі поля' });
      return;
    }

    if (!cart || cart.length === 0) {
      setMessage({ type: 'error', text: 'Кошик порожній' });
      return;
    }

    setIsSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      await dispatch(createOrder({
        orderData: values,
        cart: cart,
        userId: currentUser?.id || null,
      })).unwrap();

      setMessage({ type: 'success', text: 'Замовлення успішно оформлено! Дані надіслано на email і Telegram.' });
      
      // Очистка корзины и перенаправление через 2 секунды
      dispatch(clearCart());
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error) {
      console.error('Помилка при оформленні замовлення:', error);
      console.error('Деталі помилки:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || error.message || 'Помилка при оформленні замовлення' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    
    <section className={styles.checkout}>
      <h2 className={styles.title}>Оформлення замовлення</h2>
      {message.text && (
        <div className={`${styles.message} ${styles[message.type]}`}>
          {message.text}
        </div>
      )}
      <div className={styles.wrrap}>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.wrrap_date}>
            <div className={styles.form__inner_date}>
              <div className={styles.group}>
                <input
                  type="text"
                  placeholder="Прізвище"
                  name="lastName"
                  value={values.lastName}
                  autoComplete="off"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.group}>
                <input
                  type="text"
                  placeholder="Ім'я"
                  name="firstName"
                  value={values.firstName}
                  autoComplete="off"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.group}>
                <input
                  type="number"
                  placeholder="Номер телефону"
                  name="telephone"
                  value={values.telephone}
                  autoComplete="off"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.group}>
                <input
                  type="text"
                  placeholder="Місто доставки"
                  name="citi"
                  value={values.citi}
                  autoComplete="off"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.group}>
                <input
                  type="number"
                  placeholder="Номер відділення"
                  name="department"
                  value={values.department}
                  autoComplete="off"
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className={styles.inner__carrier_payment}>
              <div className={styles.form__carrier}>
                <p>Поштовий перевізник</p>
                <div>
                  <input 
                    type="radio" 
                    id="novaPoshta" 
                    name="carrier" 
                    value='Нова пошта' 
                    checked={values.carrier === 'Нова пошта'}
                    onChange={handleChange}
                  />
                  <label htmlFor="novaPoshta">Нова пошта</label>
                </div>
                <div>
                  <input 
                    type="radio" 
                    id="ukrPoshta"
                    name="carrier"
                    value='Укрпочта' 
                    checked={values.carrier === 'Укрпочта'}
                    onChange={handleChange}
                  />
                  <label htmlFor="ukrPoshta">Укрпочта</label>
                </div>
              </div>
              <div className={styles.form__payment}>
                <p>Форма оплати</p>
                <div>
                  <input
                    type="radio" 
                    id="card" 
                    name="payment" 
                    value='Оплата карткою' 
                    checked={values.payment === 'Оплата карткою'}
                    onChange={handleChange}
                  />
                  <label htmlFor="Card">Оплата карткою</label>
                </div>
                <div>
                  <input 
                    type="radio" 
                    id="COD" 
                    name="payment" 
                    value='Накладений платіж' 
                    checked={values.payment === 'Накладений платіж'}
                    onChange={handleChange}
                  />
                  <label htmlFor="COD">Накладений платіж</label>
                </div>
              </div>
            </div>
          </div>
          

          <button 
            type="submit" 
            className={styles.submit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Оформлення...' : 'Виконати'}
          </button>          
        </form>
      </div>
    </section>
    
  )
}

export default Checkout;
